import React from 'react'
import { useGetNotificationsQuery } from '@sketch/gql-types'

interface InboxPreviewProps {
  notificationId: string
}

/**
 * Reads a single notification from the Apollo cache — the same entries
 * the list already fetched. `cache-only` avoids hitting the backend.
 */
export const InboxPreview = ({ notificationId }: InboxPreviewProps) => {
  const { data, loading } = useGetNotificationsQuery({
    fetchPolicy: 'cache-only',
    errorPolicy: 'all',
    variables: { filter: { states: ['UNREAD', 'DONE', 'READ'] } },
  })

  if (loading) return <p>Loading…</p>

  const notification = data?.me?.notifications?.entries.find(
    entry => entry.identifier === notificationId
  )

  if (!notification) {
    return <p>Notification not found.</p>
  }

  return (
    <article>
      <h2>{notification.title}</h2>
      <p>{notification.subtitle}</p>
    </article>
  )
}
